import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { App, Avatar } from "antd";
import { useEffect } from "react";
import { Provider as LicenseProvider } from "@devowl-wp/real-product-manager-wp-client";
import { Provider } from "./provider.js";
import { rmlOpts } from "../../utils/rmlOpts.js";
import { ConfigLicensingConsumer } from "../licensing/consumer.js";
function ImmediateLicenseForm() {
    const { modal } = App.useApp();
    useEffect(()=>{
        let instance;
        // Only sibling plugin license shells — not rpm-wpc-antd nested modals (e.g. telemetry preview).
        const foreignModal = ()=>document.querySelector(".rpm-antd-modal-wrap, .rtg-antd-modal-wrap, .rcb-antd-modal-wrap, .rcl-antd-modal-wrap");
        const sync = ()=>{
            if (!rmlOpts.others.showLicenseFormImmediate || foreignModal()) {
                instance?.destroy();
                instance = undefined;
                return;
            }
            if (instance) {
                return;
            }
            instance = modal.info({
                icon: null,
                title: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            children: "Real Media Library"
                        }),
                        /*#__PURE__*/ _jsx(Provider, {
                            app: {
                                style: {
                                    float: "right"
                                }
                            },
                            children: /*#__PURE__*/ _jsx(Avatar, {
                                src: `${rmlOpts.publicUrl}images/logos/real-media-library.svg`,
                                shape: "square",
                                size: 30
                            })
                        })
                    ]
                }),
                width: 800,
                okButtonProps: {
                    style: {
                        display: "none"
                    }
                },
                cancelButtonProps: {
                    style: {
                        display: "none"
                    }
                },
                mask: {
                    closable: false
                },
                // ponytail: trap off — each WP plugin bundles its own antd; overlapping traps → syncFocus stack overflow
                focusable: {
                    trap: false
                },
                content: /*#__PURE__*/ _jsx(LicenseProvider, {
                    children: /*#__PURE__*/ _jsx(ConfigLicensingConsumer, {
                        withinModal: true,
                        onClose: ()=>instance?.destroy()
                    })
                })
            });
        };
        sync();
        // ponytail: no cross-plugin bus — yield while another devowl license modal owns the stack
        const observer = new MutationObserver(sync);
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer.disconnect();
            instance?.destroy();
        };
    }, [
        modal
    ]);
    return null;
}
export { ImmediateLicenseForm };
